module.exports = {
  basic: {
    white: '#FFFFFF',
    transparent: 'transparent',
  },
  exception: {
    100: '#E9EDF4', // Table header
  },
  neutral: {
    100: '#F4F6FA',
    200: '#D3DBE8',
    300: '#A7B6D2',
    400: '#667EB0',
    500: '#3C4E73',
    600: '#30405B',
    700: '#27334B',
    800: '#151C28',
    900: '#090D12',
  },
  primary: {
    100: '#F5FBFE',
    200: '#D6EDFB',
    300: '#ADDCF7',
    400: '#70C2F1',
    500: '#33A8EB',
    600: '#158BD0',
    700: '#1171A9',
    800: '#093D6B',
    900: '#041A27',
  },
  grey: {
    100: '#F9F9F9',
    200: '#E6E6E7',
    300: '#CCCDCF',
    400: '#A6A8AC',
    500: '#818389',
    600: '#67696E',
    700: '#53555A',
    800: '#2D2E30',
    900: '#131415',
  },
  success: {
    100: '#F7FCF8',
    200: '#DFF2E4',
    300: '#BFE5C9',
    400: '#8FD1A0',
    500: '#61BE79',
    600: '#42A25A',
    700: '#3E7B4E',
    800: '#1D4727',
    900: '#0C1E11',
  },
  warning: {
    100: '#FFF9F3',
    200: '#FFE8D0',
    300: '#FFD2A1',
    400: '#FFB05B',
    500: '#FF8B13',
    600: '#DC7200',
    700: '#B35C00',
    800: '#603200',
    900: '#291500',
  },
  error: {
    100: '#FEF5F6',
    200: '#F9D7DB',
    300: '#F3AFB7',
    400: '#EA7381',
    500: '#E1364A',
    600: '#C31D31',
    700: '#9F1827',
    800: '#550D15',
    900: '#250509',
  },
  info: {
    100: '#F5F8FC',
    200: '#D6E1F5',
    300: '#ADC4EB',
    400: '#7097DB',
    500: '#336ACA',
    600: '#2956A3',
    700: '#214685',
    800: '#122547',
    900: '#08101F',
  },
  visited: {
    100: '#F8F2FF',
    200: '#E1CCFD',
    300: '#C399FB',
    400: '#974CF9',
    500: '#6B09EC',
    600: '#5607BD',
    700: '#46069A',
    800: '#260353',
    900: '#100123',
  },
  common: {
    apple: {
      100: '#F5FCF7',
      200: '#D9F1DE',
      300: '#B3E3BD',
      400: '#79CF8C',
      500: '#42B85C',
      600: '#359349',
      700: '#2B773C',
      800: '#174020',
      900: '#0A1C0E',
    },
    blue: {
      100: '#F4FBFF',
      200: '#D1F0FF',
      300: '#A3E2FF',
      400: '#5ECCFF',
      500: '#1AB6FF',
      600: '#0099E0',
      700: '#007DB6',
      800: '#004362',
      900: '#001D2A',
    },
    pink: {
      100: '#FEF5F9',
      200: '#FAD6E7',
      300: '#F6ACCF',
      400: '#EF6EAA',
      500: '#E83086',
      600: '#CA166A',
      700: '#A41256',
      800: '#580A2E',
      900: '#260414',
    },
    chocolate: {
      100: '#FCF9F7',
      200: '#F1E6DF',
      300: '#E3CCBF',
      400: '#CFA68F',
      500: '#BA805E',
      600: '#9D6443',
      700: '#805137',
      800: '#452C1D',
      900: '#1D130D',
    },
    cherry: {
      100: '#FFF4F6',
      200: '#FED2DC',
      300: '#FEA5B9',
      400: '#FD6185',
      500: '#FC1D51',
      600: '#DD0336',
      700: '#B4032C',
      800: '#610118',
      900: '#29010A',
    },
    orange: {
      100: '#FFF6F4',
      200: '#FFDCD1',
      300: '#FFB9A3',
      400: '#FF845E',
      500: '#FF4F1A',
      600: '#E03400',
      700: '#B62B00',
      800: '#621700',
      900: '#2A0A00',
    },
    orchid: {
      100: '#FAF5FE',
      200: '#ECD6FA',
      300: '#DAACF6',
      400: '#BE6EEF',
      500: '#A230E8',
      600: '#8516CA',
      700: '#6C12A4',
      800: '#3A0A58',
      900: '#190426',
    },
    royalBlue: {
      100: '#F1F7FF',
      200: '#C5DDFE',
      300: '#8CBBFE',
      400: '#3689FD',
      500: '#025CD9',
      600: '#0249AE',
      700: '#013C8D',
      800: '#01204C',
      900: '#000E21',
    },
    teal: {
      100: '#F5FEFA',
      200: '#D6FAED',
      300: '#ACF6DB',
      400: '#6EEFC0',
      500: '#30E8A5',
      600: '#16CA88',
      700: '#12A46F',
      800: '#0A583C',
      900: '#04261A',
    },
    gold: {
      100: '#FCFAF6',
      200: '#F4ECDC',
      300: '#EAD9B8',
      400: '#DABD83',
      500: '#CAA14E',
      600: '#AD8434',
      700: '#8C6C2A',
      800: '#4C3A17',
      900: '#20190A',
    },
    yellow: {
      100: '#FFFCF5',
      200: '#FFF4D6',
      300: '#FFE9AD',
      400: '#FFD870',
      500: '#FFC835',
      600: '#F5B200',
      700: '#C79100',
      800: '#6B4E00',
      900: '#2E2100',
    },
  },
  }
